import React from "react"
import Tortas, { PieProps } from "../../../../Utiles/Charts/Torta";
import { don } from "@victorequena22/conneccion";
export interface rank {
    cantidad: number,
    estatus: number
}
export default class TortasMaster extends React.Component<{ lugar: string, rango: string, no: string }, PieProps> {
    estados = ['CANCELADO', 'PENDIENTE', 'PROCESADA'];
    api = 'Cotizacion';
    title = '';
    constructor(p: any) {
        super(p);
        this.state = { title: '', values: this.estados.map((s) => [s, 0]) };
    }
    render() {
        const { title, values } = this.state;
        return <div className={'center ' + this.props.lugar}>
            <div style={{ textAlign: 'center' }}>
                {this.isData() ? <Tortas title={title} values={values} /> :
                    <div style={{ gridAutoRows: '18rem' }} className='center'>
                        <div style={{ gridAutoRows: '12rem' }} className='no-data bg-black center'>
                            <b>SIN REGISTROS<br /> EN EL {this.props.no}</b>
                        </div>
                    </div>}
                <h5>{this.title}</h5>
            </div>
        </div>
    }
    isData() {

        if (this.state.values.some(d => d[1] > 0)) return true;
        return false;
    }
    componentDidMount() {
        this.send();
    }
    componentDidUpdate({ rango }: any) {
        if (rango !== this.props.rango)
            this.send();
    }
    async send() {
        try {
            let token = localStorage.getItem('Authorization');
            let response = await fetch(don + '/api/' + this.api + '/torta/' + this.props.rango, { headers: { 'Authorization': 'Bearer ' + token } });
            let datos: rank[] = await response.json();
            this.setState({
                values: this.estados.map((s, i) => {
                    const d = datos.find(d => d.estatus === i);
                    return [s, d ? d.cantidad : 0]
                })
            });
        } catch (error) {
            console.log(error);
            this.setState({ values: [] });
        }
    }
}